import { render, staticRenderFns } from "./SidebarGroup.vue?vue&type=template&id=b9ea2f40&scoped=true&"
import script from "./SidebarGroup.vue?vue&type=script&lang=ts&"
export * from "./SidebarGroup.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarGroup.vue?vue&type=style&index=0&id=b9ea2f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ea2f40",
  null
  
)

export default component.exports